import moment from 'moment'

import { TimeFormatsLocaleUnsafe } from '@/lib/datetime'
import { entityGenerator } from '@/lib/entityGenerator'
import { Passport, TravelerDocumentType } from '@/types/document'

export const emptyPassport = entityGenerator<Passport>({
	id: null,
	type: TravelerDocumentType.Passport,
	passport_number: '',
	citizenship: { code: '', name: '' },
	expiration_date: null,
	issue_date: null,
	issuing_country: { code: '', name: '' },
})

export function preparePassportJson(passport: Passport) {
	const copy: Partial<Passport> = { ...passport }
	delete copy.id
	copy.issue_date = moment(copy.issue_date!).format(TimeFormatsLocaleUnsafe.DateOnly)
	copy.expiration_date = moment(copy.expiration_date!).format(TimeFormatsLocaleUnsafe.DateOnly)
	return copy
}
